function isIOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(window.navigator.platform)
        // iPad on iOS 13 detection
        || (window.navigator.userAgent.includes("Mac") && "ontouchend" in window.document)
}

function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        return (ua.indexOf('chrome') == -1)
    }

    return false;
}

function getDevice() {
    let ua = String(navigator.userAgent);
    return ua.match(/iPhone|iPod/) ? 'iPhone' : (ua.match(/iPad/) ? 'iPad' : isPadPro() );
}

function isPadPro() {
    if ((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad') {
        return 'iPad';
    }
    return null
}

function isIPhone() {
    return getDevice() == 'iPhone';
}
function isIPad() {
    return getDevice() == 'iPad';
}

function isWebClip() {
    return navigator.standalone === true || !!(window.matchMedia('(display-mode: standalone)').matches);
}

function isBizChatApp() {
    const rule = /bizchat/i;
    return rule.test(window.navigator.userAgent);
}

export {
    isIOS,
    isSafari,
    isBizChatApp,
    isIPhone,
    isIPad,
    isWebClip,
}
